import React from 'react';
import { useDispatch, useStore } from 'react-redux';
// FIXME upper level import
import { CommonModalProps, ModalDictionary } from '../../app/shared/components/modalProvider/model';
import { firstModalInQueueSelector, modalQueueSlice } from './slice';

export const useModal = () => {
  const dispatch = useDispatch();
  const store = useStore<any>();

  return React.useMemo(
    () => ({
      openModal: <N extends keyof ModalDictionary>(name: N, props?: CommonModalProps & ModalDictionary[N]) => {
        dispatch(modalQueueSlice.actions.push({ name, props }));
      },
      closeModal: (name?: string) => {
        if (!name) {
          dispatch(modalQueueSlice.actions.shift());
        }
        const m = firstModalInQueueSelector(store.getState());
        if (m && m.name === name) {
          dispatch(modalQueueSlice.actions.shift());
        }
      },
    }),
    [dispatch, store],
  );
};
